module.exports = [{
      plugin: require('/Users/jeff/Projects/gatsby/gordon-zone/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/jeff/Projects/gatsby/gordon-zone/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
